/*
AND +
OR  ,
------------------------
>   greater than
>=  greater or equal to
<   less than
<=  less  or equal to
=   equal
!=  not equal
*/

// const QuotedRE = /^"[^"]*"/;
// const NumbersRE = /^\d+(?:\.\d+)?/;

const KeywordsRE = /^(?:AND|OR)\b/;
const OperatorsRE = /^(?:(?:(<|>)=?)|(?:\!?=))/;

export const filterBarMode = {
    name: 'filterbar',
    startState: () => ({}),
    token: (stream, state) => {
        const prevAteSpace = state.ateSpace;
        if (!(state.ateSpace = stream.eatSpace())) {
            let style;
            if (stream.match(KeywordsRE)) {
                style = prevAteSpace && 'keyword';
            } else if (stream.match(OperatorsRE)) {
                style = 'operator';
            }
            // else if (stream.match(NumbersRE)) { style = 'number' }
            // else if (stream.match(QuotedRE)) { style = 'string }'
            if (style) {
                // console.log(style, stream.current());
                return style;
            } else {
                stream.next();
            }
        }
        return null;
    }
};
